const moduleSelectedConsultationType = {
    namespaced: true,
    state: {
        loading: false,
        selectedConsultationType: null,
    },
    getters: {
        getSelectedConsultationType(state) {
            return state.selectedConsultationType;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setSelectedConsultationType(state, selectedConsultationType) {
            state.selectedConsultationType = selectedConsultationType;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
};
export default moduleSelectedConsultationType;
